!function($, window, document) {
    const $win = $(window);
    $(document), $(document.body);
    function window_width() {
        return $win.width();
    }
    function is_mobile() {
        return window_width() <= 767;
    }
    function updateHeaderHeight() {
        const topBarHeight = $(".top--bar").outerHeight();
        document.documentElement.style.setProperty("--header-height", `${topBarHeight || 0}px`);
    }
    $(".menu-item-has-children").on("mouseenter focus focusin", (function() {
        $(".top--bar").addClass("sub-menu-open");
    })).on("mouseleave blur focusout", (function() {
        $(".top--bar").removeClass("sub-menu-open");
    })), $(".menu-item-has-children > a").on("click", (function(e) {
        if (is_mobile()) return e.preventDefault(), !1;
    })), updateHeaderHeight(), AOS.init({
        delay: 0,
        duration: 1e3,
        anchorPlacement: "top-bottom",
        disable: "mobile"
    });
    var timers, waitForFinalEvent = (timers = {}, function(callback, ms, uniqueId) {
        uniqueId || (uniqueId = "Don't call this twice without a uniqueId"), timers[uniqueId] && clearTimeout(timers[uniqueId]), 
        timers[uniqueId] = setTimeout(callback, ms);
    });
    $(".js-value-heading").on("click", (function(e) {
        let $valueBody = $(this).next(".value-body");
        $valueBody.length && $valueBody.slideToggle();
    })), $(document).ready((function() {
        const filterParam = new URLSearchParams(window.location.search).get("filter");
        filterParam && function applyProjectFilter(sector) {
            if (!sector) return;
            const $filterLink = $(`.js-projects-filter button[data-filter="${sector}"]`);
            $filterLink.length && ($filterLink.parents("ul").eq(0).find("button").removeClass("active"), 
            $filterLink.addClass("active"), $(".project-grid-item").removeClass("is-featured").hide(), 
            $('.project-grid-item[data-sector="' + sector + '"]').show(), $('.project-grid-item[data-sector="' + sector + '"]').eq(0).addClass("is-featured"));
        }(filterParam);
    }));
    const animateScrollToTop = () => {
        $(window).scrollTop() > 0 && $("html, body").animate({
            scrollTop: 0
        }, {
            duration: 500,
            easing: "swing"
        });
    };
    $(".js-projects-filter").on("click", "button", (function(e) {
        e.preventDefault();
        let $this = $(this), filteredSector = $this.attr("data-filter");
        if (animateScrollToTop(), $this.hasClass("active")) {
            const newUrl = new URL(window.location);
            newUrl.searchParams.delete("filter"), window.history.pushState({}, "", newUrl), 
            $this.removeClass("active"), $(".project-grid-item").hide(), $('.project-grid-item[data-featured="1"]').show();
        } else {
            const newUrl = new URL(window.location);
            newUrl.searchParams.set("filter", filteredSector), window.history.pushState({}, "", newUrl), 
            $this.parents("ul").eq(0).find("button").removeClass("active"), $this.addClass("active"), 
            $(".project-grid-item").removeClass("is-featured").hide(), $('.project-grid-item[data-sector="' + filteredSector + '"]').show(), 
            $('.project-grid-item[data-sector="' + filteredSector + '"]').eq(0).addClass("is-featured");
        }
    })), $(".js-filter-toggle").on("click", (function(e) {
        let $this = $(this), $filterBody = $this.next(".filters--body");
        $this.toggleClass("active"), $filterBody.length && ($filterBody.is(":visible") ? $filterBody.slideUp((function() {
            $filterBody.css("display", "none");
        })) : $filterBody.css("display", window_width() <= 767 ? "block" : "flex").hide().slideDown());
    }));
    var viewport = function updateViewportDimensions() {
        var w = window, d = document, e = d.documentElement, g = d.getElementsByTagName("body")[0];
        return {
            width: w.innerWidth || e.clientWidth || g.clientWidth,
            height: w.innerHeight || e.clientHeight || g.clientHeight
        };
    }();
    equalheight = function(container) {
        var $el, currentTallest = 0, currentRowStart = 0, rowDivs = new Array;
        $(container).each((function() {
            if ($el = $(this), $($el).height("auto"), topPostion = $el.position().top, currentRowStart != topPostion) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) rowDivs[currentDiv].height(currentTallest);
                rowDivs.length = 0, currentRowStart = topPostion, currentTallest = $el.height(), 
                rowDivs.push($el);
            } else rowDivs.push($el), currentTallest = currentTallest < $el.height() ? $el.height() : currentTallest;
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) rowDivs[currentDiv].height(currentTallest);
        }));
    };
    var _body = $("body"), _megamenu = $(".site--mega-menu"), _megamenuResults = $(".site--mega-menu-results"), _siteHeader = $(".site--header"), _searchForm = $("#search-form"), _contactForm = $(".in-menu-enquiry"), _windowHeight = $(window).height(), scroll = $(window).scrollTop();
    function blur() {
        var fullscreen_slider_width = $(".fullscreen--carousel").width(), project_slider_width = $(".project--carousel").width();
        $(".slide--caption-bg-inside").css("width", fullscreen_slider_width), $(".slide-blurred .slide").css("width", project_slider_width), 
        _windowHeight = $(window).height();
    }
    function resizeEvents() {
        blur();
    }
    function loadMorePosts(selector, max_selector) {
        var infScroll = selector.data("infiniteScroll"), maxPages = max_selector.attr("data-max-num-pages");
        void 0 !== infScroll && infScroll.loadCount < parseInt(maxPages - 1) && this.loadCount != infScroll.pageIndex && "" !== $gridProjects.data("next-url-pattern") && selector.infiniteScroll("loadNextPage");
    }
    blur(), $(".js-anchor-link").on("click", (function(e) {
        e.preventDefault(), goToByScroll($(this).attr("href").replace("#", ""), 0, 750);
    })), function initPeopleIsotope() {
        $(".iso-grid-people");
        var $gridPeople = $(".iso-grid-people").isotope({
            itemSelector: "none",
            percentPosition: !0,
            stagger: 30,
            visibleStyle: {
                transform: "translateY(0)",
                opacity: 1
            },
            hiddenStyle: {
                transform: "translateY(100px)",
                opacity: 0
            },
            layoutMode: "fitRows",
            filter: ".partners",
            transitionDuration: 0,
            vertical: {
                horizontalAlignment: 0
            },
            getSortData: {
                name: ".name",
                jobtitle: ".jobtitle"
            }
        });
        $gridPeople.isotope({
            filter: "*"
        });
        $gridPeople.data("isotope");
        $gridPeople.imagesLoaded((function() {
            $gridPeople.isotope("option", {
                itemSelector: ".iso-grid-item-people"
            });
            var $items = $gridPeople.find(".iso-grid-item-people");
            $gridPeople.isotope("appended", $items);
        })), $(document).on("mouseover", ".iso-grid-item-people.hunet", (function(e) {
            e.preventDefault(), $(".iso-grid-item-people.hunet").find(".popup-profile").removeClass("show-profile"), 
            $(this).find(".popup-profile").addClass("show-profile");
        })), $(document).on("mouseout", ".popup-profile", (function(e) {
            e.preventDefault(), $(".iso-grid-item-people.hunet").find(".popup-profile").removeClass("show-profile");
        })), $(document).on("mouseout", ".people--wrapper", (function(e) {
            e.preventDefault(), $(".iso-grid-item-people.hunet").find(".popup-profile").removeClass("show-profile");
        })), $(".filter-layout.people-layout").on("click", (function(e) {
            e.preventDefault(), e.stopPropagation();
            var _this = $(this), layout = _this.attr("data-title").toLowerCase();
            "vertical" == layout ? $(".iso-grid-item-people").addClass("hunet") : $(".iso-grid-item-people").removeClass("hunet"), 
            $(".filter-layout").removeClass("selected"), _this.addClass("selected"), $gridPeople.isotope({
                layoutMode: layout
            });
        })), $gridPeople.on("arrangeComplete", (function(event, filteredItems) {
            0 == filteredItems.length ? $("#no-results-msg").addClass("show-me") : $("#no-results-msg").removeClass("show-me");
        })), $(".filter-sort").on("change", (function() {
            var sortValue = $("#abc").children("option:selected").val(), cur_filter = $("#people-grid").attr("data-current-filter");
            $("#people-grid").attr("data-current-location", sortValue), $(".filter-list").hasClass("selected") && $("#people-grid").attr("data-current-person", ""), 
            $(".filter-thumbnail").hasClass("selected") && $("#people-grid").attr("data-current-person", ".primary");
            var person_filter = $("#people-grid").attr("data-current-person");
            $gridPeople.isotope({
                filter: person_filter + cur_filter + sortValue
            });
        })), $(".type--filter button, .people--filter button").on("click", (function(e) {
            e.preventDefault(), e.stopPropagation();
            const $this = $(this), isLocationFilter = $this.parents(".filter--locations").length > 0, filterValue = $this.attr("data-filter"), cleanTitle = $this.text().replace(" Studio", ""), $peopleGrid = $("#people-grid");
            isLocationFilter ? $this.hasClass("active") ? ($this.removeClass("active"), $peopleGrid.attr("data-current-location", "")) : ($(".filter--locations button").removeClass("active"), 
            $this.addClass("active"), $peopleGrid.attr("data-current-location", filterValue)) : $this.hasClass("active") ? ($this.removeClass("active"), 
            $peopleGrid.attr("data-current-filter", "*"), $(".type--description").css("opacity", "0")) : ($(".type--filter ul:not(.filter--locations) button, .people--filter ul:not(.filter--locations) button").removeClass("active"), 
            $this.addClass("active"), $peopleGrid.attr("data-current-filter", filterValue));
            const activeTypeFilter = $(".type--filter ul:not(.filter--locations) button.active, .people--filter ul:not(.filter--locations) button.active").attr("data-filter") || "*", activeLocationFilter = $(".filter--locations button.active").attr("data-filter") || "", personFilter = "View All" === cleanTitle ? "" : $(".filter-thumbnail").hasClass("selected") ? ".primary" : "";
            $peopleGrid.attr("data-current-filter", activeTypeFilter), $peopleGrid.attr("data-current-location", activeLocationFilter), 
            $peopleGrid.attr("data-current-person", personFilter), "*" !== activeTypeFilter ? ($(".type--description").css("opacity", "1").removeClass("show-description"), 
            $(`.type--description${activeTypeFilter}`).addClass("show-description")) : $(".type--description").css("opacity", "0"), 
            $gridPeople.isotope({
                filter: personFilter + activeLocationFilter + activeTypeFilter
            });
            const activeTitle = "*" === activeTypeFilter ? "Our People" : $(".type--filter button.active, .people--filter button.active").text().replace(" Studio", "");
            $(".dynamic-title").text(activeTitle), $("#no-results-msg").toggleClass("show-me", !$(".type--filter button.active, .people--filter button.active").length), 
            animateScrollToTop(), goToByScroll("insights-archive", 98, 250);
        })), $("#abc").select2({
            minimumResultsForSearch: -1,
            placeholder: "Abc",
            dropdownCssClass: "filter-dropdown",
            containerCssClass: "filter-abc-select2",
            width: "auto"
        });
    }(), $(window).on("load", (function() {
        resizeEvents(), parallaxImages(), function initStudioNav() {
            $(".anim-in--left, .anim-in--right").filter(":visible").not(".anim-in--active").addClass("anim-in--active");
        }(), setTimeout(AOS.refreshHard, 150), scroll >= 1 && _siteHeader.addClass("scrolling"), 
        $(".section-1").length && window.location.pathname;
    })), $(window).on("load", (function() {
        AOS.refresh();
    })), $(window).resize((function() {
        waitForFinalEvent((function() {
            resizeEvents();
        }), 100, "all-my-resize-events"), updateHeaderHeight();
    })), $(".js-open-search").on("click", (function(e) {
        console.log("Toggling Search"), $("#search-form").toggleClass("show--menu"), is_mobile() ? ($(".menu").css({
            opacity: 0,
            pointerEvents: "none"
        }), $(".search-mobile").css({
            opacity: 0,
            pointerEvents: "none"
        })) : $(".site--mega-menu").toggleClass("open"), setTimeout((function() {
            $("#search-value").select2("open");
        }), 300);
    })), $("ul#primary a, ul#primary-mobile a").each((function() {
        var _this = $(this), _menu_name = _this.text().toLowerCase().replace(" ", "-");
        _this.hover((function() {
            _this.parent().siblings().find("a").addClass("inactive-hover");
        }), (function() {
            _this.parent().siblings().find("a").removeClass("inactive-hover");
        })), _this.click((function(e) {
            _this.parent().hasClass("dont-activate-mega") || (_siteHeader.hasClass("open") || _siteHeader.toggleClass("open"), 
            _megamenu.hasClass("open") || $(".hamburger button").toggleClass("clicked"), $("#secondary > li").removeClass("show--menu"), 
            _searchForm.removeClass("show--menu"), _contactForm.removeClass("show--menu"), setTimeout((function() {
                "search" == _menu_name ? (_searchForm.addClass("show--menu"), setTimeout((function() {
                    $("#search-value").select2("open");
                }), 300)) : "contact" == _menu_name ? (_contactForm.addClass("show--menu"), $("#secondary").find('a[rel="' + _menu_name + '"]').parent().addClass("show--menu")) : $("#secondary").find('a[rel="' + _menu_name + '"]').parent().addClass("show--menu");
            }), 250));
        }));
    })), $(".search--people").click((function(e) {
        e.preventDefault(), $("nav.main--site_navigation li.search a").trigger("click");
    })), _megamenuResults.on("click", ".close-btn", (function(e) {
        _megamenuResults.removeClass("open");
    })), $(".search--search-header a").click((function() {
        $("#primary-mobile").removeClass("mobile--menu-open"), $("#search-form").removeClass("show--menu"), 
        is_mobile() && ($(".menu").css({
            opacity: 1,
            pointerEvents: "initial"
        }), $(".search-mobile").css({
            opacity: 1,
            pointerEvents: "initial"
        }));
    })), $(".hamburger button").on("click", (function() {
        $(this).hasClass("clicked") ? $(this).removeClass("clicked") : $(this).addClass("clicked"), 
        scroll = $(window).scrollTop(), _megamenu.toggleClass("open"), _megamenuResults.removeClass("open"), 
        _body.toggleClass("fixed"), _searchForm.removeClass("show--menu"), _contactForm.removeClass("show--menu"), 
        _windowWidth = $(window).width(), $(".site--mega-menu-results .projects--results-header").fadeOut(), 
        _siteHeader.toggleClass("open"), $("#secondary > li").removeClass("show--menu"), 
        $("ul#primary a, ul#primary-mobile a").removeClass("active").removeClass("inactive"), 
        $("ul#primary-mobile").removeClass("mobile--menu-open"), _siteHeader.hasClass("scrolling") ? _siteHeader.removeClass("scrolling") : scroll >= _windowHeight && _siteHeader.addClass("scrolling"), 
        $(this).hasClass("clicked") && _windowWidth >= 1024 && $("ul#primary li:first-of-type a").trigger("click");
    })), $(".back-to-top").on("click", (function(e) {
        e.preventDefault(), $("html, body").animate({
            scrollTop: 0
        }, {
            duration: 800,
            easing: "swing"
        });
    })), $(window).scroll((function() {
        scroll = $(window).scrollTop();
        var header = $(".site--header"), hamburger = $(".hamburger"), backtotop = $(".back-to-top"), fullscreenSlider = $(".fader");
        if ($(".people--wrapper").length) {
            var $sectionPeopleOffset = $(".people--wrapper").offset().top;
            scroll > $sectionPeopleOffset - 100 ? $(".popup-profile").addClass("fixed") : $(".popup-profile").removeClass("fixed");
        }
        fullscreenSlider.length && scroll >= 150 ? fullscreenSlider.addClass("bg-transition") : fullscreenSlider.removeClass("bg-transition"), 
        scroll >= 1 && !header.hasClass("open") ? (hamburger.addClass("scrolling"), backtotop.addClass("showing"), 
        header.hasClass("clicked") || header.addClass("scrolling")) : (hamburger.removeClass("scrolling"), 
        header.removeClass("scrolling"), backtotop.removeClass("showing")), 0 != scroll || $(".hamburger button").hasClass("clicked") || (header.removeClass("clicked"), 
        $(".hamburger button").removeClass("clicked"));
        var dynamicTitle = $(".dynamic-section-title"), currentTitle = $(".dynamic-section-title").text(), elems = $("section");
        elems.each((function(index) {
            var _thisElems = $(this), elemTop = $(this).offset().top - 1, elemBottom = elemTop + $(this).height();
            if (scroll >= elemTop && scroll <= elemBottom && !_thisElems.hasClass("in--section")) {
                var id = $(this).attr("data-module-id");
                if (id) {
                    var name = id.replace(/-/g, " ");
                    elems.removeClass("in--section"), _thisElems.addClass("in--section"), name != currentTitle && (dynamicTitle.addClass("hide--breadcrumb"), 
                    setTimeout((function() {
                        dynamicTitle.text(name).removeClass("hide--breadcrumb");
                    }), 250));
                }
            }
        }));
    }));
    var $gridProjects, $gridProjectsSelector = $(".iso-grid-projects");
    ($gridProjects = $(".iso-grid-projects").isotope({
        itemSelector: "iso-grid-item-projects",
        percentPosition: !0,
        transitionDuration: 0,
        stagger: 30,
        visibleStyle: {
            transform: "translateY(0)",
            opacity: 1
        },
        hiddenStyle: {
            transform: "translateY(100px)",
            opacity: 0
        },
        layoutMode: "masonry",
        masonry: {
            columnWidth: ".grid__col-sizer--projects",
            gutter: ".grid__gutter-sizer--projects"
        },
        getSortData: {
            number: ".date-order parseInt"
        }
    })).data("isotope");
    $gridProjects.imagesLoaded((function() {
        $gridProjects.removeClass("are-images-unloaded"), $gridProjects.isotope("option", {
            itemSelector: ".iso-grid-item-projects"
        });
        var $items = $gridProjects.find(".iso-grid-item-projects");
        $gridProjects.isotope("appended", $items);
    })), "" !== $gridProjects.data("next-url-pattern") && $(".lazy-loading").appear(), 
    $(document.body).on("appear", ".lazy-loading", (function(e, $affected) {
        $gridProjectsSelector = $(".iso-grid-projects"), loadMorePosts($gridProjects = $(".iso-grid-projects").isotope(), $gridProjectsSelector);
    })), $("#sector.filter-select, #location.filter-select").on("change", (function() {
        var location = $("#location").children("option:selected").val(), sector = $("#sector").children("option:selected").val();
        window.location = "*" !== location ? sector + "" : sector;
    })), $gridProjects.on("arrangeComplete", (function(event, filteredItems) {
        0 == filteredItems.length ? $("#no-results-msg").addClass("show-me") : $("#no-results-msg").removeClass("show-me");
    })), $(".filter-layout.projects-layout").on("click", (function(e) {
        e.preventDefault(), e.stopPropagation();
        var _this = $(this), layout = _this.attr("data-title").toLowerCase();
        $(".projects--data").addClass("currently-loading"), $(".filter-layout").removeClass("selected"), 
        _this.addClass("selected");
        var elToRemove = $gridProjects.isotope("getItemElements");
        $gridProjects.isotope("remove", elToRemove), $.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: "post",
            data: {
                action: "chriate_projects_list",
                layout: layout
            },
            success: function(result) {
                $gridProjects.isotope("insert", $(result)), "list" == layout ? ($(".lazy-loading").addClass("set-off-page"), 
                $(".section--projects h1.dynamic-projects-header").text("All Projects"), $(".iso-grid").addClass("list-grid-wrapper"), 
                $(".projects--list-archive").hide(), $gridProjects.isotope({
                    sortBy: "number",
                    sortAscending: !0
                })) : ($(".lazy-loading").removeClass("set-off-page"), $(".projects--list-archive").show(), 
                $(".section--projects h1.dynamic-projects-header").text("Featured Projects"), $(".iso-grid").removeClass("list-grid-wrapper"), 
                $gridProjects.isotope({
                    sortBy: "*",
                    sortAscending: !0
                })), $gridProjects.isotope("layout"), setTimeout((function() {
                    $(".projects--data").removeClass("currently-loading");
                }), 1e3);
            },
            error: function(result) {
                console.log(result), alert(result);
            }
        });
    })), $("#sector").select2({
        minimumResultsForSearch: -1,
        placeholder: "Sector",
        dropdownCssClass: "filter-dropdown",
        containerCssClass: "filter-sector-select2",
        width: "auto"
    }), $("#location").select2({
        minimumResultsForSearch: -1,
        placeholder: "Location",
        containerCssClass: "filter-location-select2",
        dropdownCssClass: "filter-dropdown",
        width: "auto"
    }), function initInsightIsotope() {
        var $gridInsightsSelector = $(".iso-grid-insights"), $gridInsights = $(".iso-grid-insights").isotope({
            itemSelector: "none",
            percentPosition: !0,
            transitionDuration: 0,
            stagger: 30,
            visibleStyle: {
                transform: "translateY(0)",
                opacity: 1
            },
            hiddenStyle: {
                transform: "translateY(100px)",
                opacity: 0
            },
            layoutMode: "masonry",
            masonry: {
                columnWidth: ".grid__col-sizer--insights",
                gutter: ".grid__gutter-sizer--insights",
                horizontalOrder: !0
            }
        }), msnry = $gridInsights.data("isotope");
        $gridInsights.imagesLoaded((function() {
            $gridInsights.removeClass("are-images-unloaded"), $gridInsights.isotope("option", {
                itemSelector: ".iso-grid-item-insights",
                layoutMode: "masonry",
                percentPosition: !0,
                masonry: {
                    columnWidth: ".grid__col-sizer--insights",
                    gutter: ".grid__gutter-sizer--insights",
                    horizontalOrder: !0
                }
            });
            var $items = $gridInsights.find(".iso-grid-item-insights");
            $gridInsights.isotope("appended", $items);
        })), $gridInsights.infiniteScroll({
            path: "/insights/page/{{#}}/",
            append: ".iso-grid-item-insights",
            outlayer: msnry,
            status: ".page-load-status",
            loadOnScroll: !1,
            history: !1
        }), $gridInsights.on("arrangeComplete", (function(event, filteredItems) {
            0 == filteredItems.length ? $("#no-results-msg").addClass("show-me") : $("#no-results-msg").removeClass("show-me");
        })), $(".lazy-loading-insights").appear(), $(document.body).on("appear", ".lazy-loading-insights", (function(e, $affected) {
            loadMorePosts($gridInsights, $gridInsightsSelector);
        })), $("#categories.filter-select").on("change", (function() {
            var category = $("#categories").children("option:selected").val();
            $gridInsights.isotope({
                filter: category
            }), loadMorePosts($gridInsights, $gridInsightsSelector);
        })), $("#categories").select2({
            minimumResultsForSearch: -1,
            placeholder: "Sector",
            dropdownCssClass: "filter-dropdown",
            containerCssClass: "filter-sector-select2",
            width: "auto"
        });
    }(), _searchForm.submit((function(e) {
        e.preventDefault();
        var $searchTerm = $("#search-value").val();
        "" != $searchTerm && (_searchForm.find("button").toggleClass("searching"), $(".select2-search__field").hide(), 
        $(".site--mega-menu-results .search--results-header").show(), $.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: "post",
            data: {
                action: "chriate_advanced_search",
                searchterm: $searchTerm.toString()
            },
            success: function(result) {
                _megamenuResults.hasClass("open") || _megamenuResults.addClass("open"), _searchForm.find("button").toggleClass("searching"), 
                $(".search--results").html(result);
            },
            error: function(result) {
                console.log(result);
            }
        }));
    })), $("#search-value").select2({
        width: "90%",
        dropdownCssClass: "advanced-search-dropdown",
        multiple: !0,
        maximumSelectionSize: 1,
        minimumInputLength: 2,
        tags: !0,
        placeholder: "Enter Your Search Here",
        language: {
            inputTooShort: function(e) {
                return "";
            }
        }
    }), $("#search-value").on("select2:closing", (function(e) {
        let selectedLink = $(this).find(":selected").attr("data-link");
        void 0 !== selectedLink && selectedLink.length > 0 ? window.location = selectedLink : _searchForm.submit();
    })), $("#search-value").on("select2:unselecting", (function(e) {
        $(".select2-search__field").show();
    })), $("#search-value").on("select2:open", (function(e) {
        $(".select2-selection__choice__remove").trigger("click"), setTimeout((function() {
            $(".select2-search__field").focus();
        }), 100);
    })), $(".show-location-details-btn").click((function(e) {
        e.preventDefault(), $(".location-details").toggleClass("hidden");
    })), $(".js-image-carousel").slick({
        infinite: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: !0,
        variableWidth: !0,
        centerMode: !0,
        touchThreshold: 20
    });
    const $fullScreenSlider = $(".js-fullscreen-slider"), $currentSlide = $fullScreenSlider.parent().find(".current--slide");
    $fullScreenSlider.slick({
        infinite: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: !0,
        arrows: !0,
        autoplay: !0,
        autoplaySpeed: 5e3
    }), $fullScreenSlider.on("afterChange", (function(event, slick, currentSlide) {
        $currentSlide.css("opacity", 0), setTimeout((function() {
            $currentSlide.css("opacity", 1);
            const slideNumber = (currentSlide + 1).toString().padStart(2, "0");
            $currentSlide.text(slideNumber);
        }), 200);
    }));
    var $slickAwards = $(".awards-slider");
    $slickAwards.on("init reInit afterChange", (function(event, slick, currentSlide, nextSlide) {
        var i = (currentSlide || 0) + 1, $theCurrentSlideDiv = $(".awards-paging-info .pagingInfo .current--slide");
        "init" != event.type ? ($theCurrentSlideDiv.addClass("hide"), setTimeout((function() {
            $theCurrentSlideDiv.text("0" + i).removeClass("hide");
        }), 200)) : $theCurrentSlideDiv.text("0" + i).removeClass("hide"), setTimeout((function() {
            $(".awards-paging-info .pagingInfo .total--slides").text("0" + slick.slideCount);
        }), 200);
    })), $slickAwards.slick({
        arrows: !0,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !1,
        swipeToSlide: !1,
        infinite: !1,
        adaptiveHeight: !1,
        nextArrow: "#awards-next",
        prevArrow: "#awards-prev",
        draggable: !0
    }), $awardsSlider = $(".award-slider"), $awardsSlider.slick({
        arrows: !0,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !1,
        swipeToSlide: !1,
        infinite: !1,
        draggable: !0
    });
    var $slickProjectList = $(".projects--list-archive-slider");
    $slickProjectList.on("init reInit afterChange", (function(event, slick, currentSlide, nextSlide) {
        var i = (currentSlide || 0) + 1, $theCurrentSlideDiv = $(".standard-paging-info .pagingInfo .current--slide");
        "init" != event.type ? ($theCurrentSlideDiv.addClass("hide"), setTimeout((function() {
            $theCurrentSlideDiv.text("0" + i).removeClass("hide");
        }), 200)) : $theCurrentSlideDiv.text("0" + i).removeClass("hide"), $(".standard-paging-info .pagingInfo .total--slides").text("0" + slick.slideCount);
    })), $slickProjectList.slick({
        arrows: !0,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !1,
        swipeToSlide: !1,
        infinite: !1,
        nextArrow: "#project-list-next",
        prevArrow: "#project-list-prev",
        draggable: !1
    }), $(".show-project-slider").click((function(e) {
        e.preventDefault(), $(".project-metadata").addClass("show"), $(".project--carousel-wrap").addClass("push"), 
        $(".show-project-slider").hide(), $(".hide-project-slider").show();
    })), $(".hide-project-slider").click((function(e) {
        e.preventDefault(), $(".project-metadata").removeClass("show"), $(".project--carousel-wrap").removeClass("push"), 
        $(".show-project-slider").show(), $(".hide-project-slider").hide();
    }));
    var $slickProject = $(".project--carousel");
    $slickProject.on("init reInit afterChange", (function(event, slick, currentSlide, nextSlide) {
        var i = (currentSlide || 0) + 1, $theCurrentSlideDiv = $(".project-paging-info .pagingInfo .current--slide");
        "init" != event.type ? ($theCurrentSlideDiv.addClass("hide"), setTimeout((function() {
            $theCurrentSlideDiv.text("0" + i).removeClass("hide");
        }), 200)) : $theCurrentSlideDiv.text("0" + i).removeClass("hide"), $(".project-paging-info .pagingInfo .total--slides").text("0" + slick.slideCount), 
        1 == slick.slideCount && $(".project-paging-info").hide();
    })), $slickProject.slick({
        arrows: !0,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !1,
        swipeToSlide: !1,
        nextArrow: "#project-next",
        prevArrow: "#project-prev",
        draggable: !1
    });
    var $slickCategory = $(".category--slider"), $slickCategoryHeader = $(".category--slider-header");
    $slickCategory.slick({
        arrows: !1,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !1,
        infinite: !1,
        fade: !0,
        swipeToSlide: !1,
        draggable: !1,
        waitForAnimate: !1,
        speed: 300
    }), $slickCategoryHeader.slick({
        arrows: !1,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !1,
        infinite: !1,
        fade: !0,
        swipeToSlide: !1,
        draggable: !1,
        waitForAnimate: !1,
        speed: 300
    }), $(".category_slider .table-content ul li a").hover((function(e) {
        e.preventDefault(), $(".category_slider .table-content ul li a").removeClass("active"), 
        $(this).addClass("active");
        var slideIndex = $(this).attr("data-slide-index");
        $slickCategory.slick("slickGoTo", parseInt(slideIndex)), $slickCategoryHeader.slick("slickGoTo", parseInt(slideIndex));
    }));
    var $slickStandard = $(".standard--carousel");
    $slickStandard.on("init reInit afterChange", (function(event, slick, currentSlide, nextSlide) {
        var i = (currentSlide || 0) + 1, $theCurrentSlideDiv = $(".carousel--content .pagingInfo .current--slide");
        "init" != event.type ? ($theCurrentSlideDiv.addClass("hide"), setTimeout((function() {
            $theCurrentSlideDiv.text("0" + i).removeClass("hide");
        }), 200)) : $theCurrentSlideDiv.text("0" + i).removeClass("hide"), $(".carousel--content .pagingInfo .total--slides").text("0" + slick.slideCount);
    }));
    var slides = 1;
    "small" == $slickStandard.data("size") && (slides = 3), $slickStandard.slick({
        arrows: !0,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !1,
        swipeToSlide: !1,
        nextArrow: "#standard-next",
        prevArrow: "#standard-prev",
        draggable: !1,
        centerMode: !0,
        centerPadding: "130px",
        slidesToShow: slides,
        responsive: [ {
            breakpoint: 1200,
            settings: {
                centerPadding: "50px"
            }
        }, {
            breakpoint: 992,
            settings: {
                centerPadding: "40px"
            }
        }, {
            breakpoint: 768,
            settings: {
                centerPadding: "20px",
                slidesToShow: 1
            }
        } ]
    });
    var $slickProjectsModule = $(".project---module-carousel");
    $slickProjectsModule.on("init reInit afterChange", (function(event, slick, currentSlide, nextSlide) {
        var i = (currentSlide || 0) + 1, $theCurrentSlideDiv = $(".carousel--content .pagingInfo .current--slide");
        "init" != event.type ? ($theCurrentSlideDiv.addClass("hide"), setTimeout((function() {
            $theCurrentSlideDiv.text("0" + i).removeClass("hide");
        }), 200)) : $theCurrentSlideDiv.text("0" + i).removeClass("hide"), $(".carousel--content .pagingInfo .total--slides").text("0" + slick.slideCount);
    })), $slickProjectsModule.slick({
        arrows: !0,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !1,
        infinite: !0,
        autoplaySpeed: 5e3,
        swipeToSlide: !1,
        nextArrow: "#project-next",
        prevArrow: "#project-prev",
        asNavFor: ".caption--carousel",
        draggable: !1,
        centerMode: !0,
        centerPadding: "130px",
        slidesToShow: 1,
        responsive: [ {
            breakpoint: 1200,
            settings: {
                centerPadding: "50px"
            }
        }, {
            breakpoint: 992,
            settings: {
                centerPadding: "40px"
            }
        }, {
            breakpoint: 768,
            settings: {
                centerPadding: "20px"
            }
        } ]
    }), $(".caption--carousel").slick({
        arrows: !1,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !1,
        fade: !0,
        swipeToSlide: !1,
        draggable: !1,
        adaptiveHeight: !0
    }), $(".fullscreen--carousel").slick({
        arrows: !1,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplaySpeed: 8e3,
        autoplay: !0,
        asNavFor: ".fullscreen--carousel-nav",
        swipeToSlide: !1,
        fade: !0,
        draggable: !1
    }), $(".js-home-anchor").on("click", (function(e) {
        e.preventDefault(), console.log(), $(window).width() <= 767 ? $("html, body").animate({
            scrollTop: $(window).outerHeight() + "px"
        }, 800) : $("html, body").animate({
            scrollTop: $(".section-1").outerHeight() + "px"
        }, 800);
    }));
    var $slickNavElement = $(".fullscreen--carousel-nav");
    $slickNavElement.on("init reInit afterChange", (function(event, slick, currentSlide, nextSlide) {
        var i = (currentSlide || 0) + 1, $theCurrentSlideDiv = $(".fullscreen_slider .pagingInfo .current--slide");
        "init" != event.type ? ($theCurrentSlideDiv.addClass("hide"), setTimeout((function() {
            $theCurrentSlideDiv.text("0" + i).removeClass("hide");
        }), 200)) : $theCurrentSlideDiv.text("0" + i).removeClass("hide"), $(".fullscreen_slider .pagingInfo .total--slides").text("0" + slick.slideCount);
    })), $slickNavElement.slick({
        arrows: !0,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !1,
        asNavFor: ".fullscreen--carousel",
        nextArrow: "#slick-next",
        prevArrow: "#slick-prev",
        fade: !0,
        swipeToSlide: !1,
        draggable: !1
    }), $slickInsightArticles = $(".insight--articles-slider"), $slickInsightArticles.slick({
        arrows: !0,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !1,
        autoplaySpeed: 5e3,
        swipeToSlide: !0,
        infinite: !0,
        draggable: !1,
        slidesToShow: 3,
        responsive: [ {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 576,
            settings: {
                slidesToShow: 1
            }
        } ]
    }), $slickStories = $(".careers--story-slider"), $slickStories.on("init reInit afterChange", (function(event, slick, currentSlide, nextSlide) {
        var i = (currentSlide || 0) + 1, $theCurrentSlideDiv = $(".careers_stories .pagingInfo .current--slide");
        "init" != event.type ? ($theCurrentSlideDiv.addClass("hide"), setTimeout((function() {
            $theCurrentSlideDiv.text("0" + i).removeClass("hide");
        }), 200)) : $theCurrentSlideDiv.text("0" + i).removeClass("hide"), $(".careers_stories .pagingInfo .total--slides").text("0" + slick.slideCount);
    })), $slickStories.slick({
        arrows: !0,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !1,
        swipeToSlide: !0,
        infinite: !1,
        draggable: !1,
        nextArrow: "#story-next",
        prevArrow: "#story-prev",
        rows: 0,
        slidesToShow: 3,
        responsive: [ {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 576,
            settings: {
                slidesToShow: 1
            }
        } ]
    }), $("#story-filter").select2({
        minimumResultsForSearch: -1,
        placeholder: "All",
        dropdownCssClass: "filter-dropdown",
        containerCssClass: "filter-story-select2",
        width: "auto"
    }), $(".story-filter").on("change", (function() {
        var storyFilter = $("#story-filter").children("option:selected").val();
        "*" != storyFilter ? ($slickStories.slick("slickUnfilter"), $slickStories.slick("slickFilter", storyFilter)) : $slickStories.slick("slickUnfilter");
    })), $("body").hasClass("page-template-page-join-us") && (equalheight(".insights-thumb-content"), 
    $(window).on("load", (function() {
        $(".story-filter").trigger("change");
    })), $(window).resize((function() {
        waitForFinalEvent((function() {
            equalheight(".insights-thumb-content");
        }), 100, "story-resize-events");
    }))), $(".section--projects--tiles").length > 0 && (equalheight(".section--projects--tiles .project-info"), 
    $(window).on("load", (function() {
        $(".story-filter").trigger("change");
    })), $(window).resize((function() {
        waitForFinalEvent((function() {
            equalheight(".section--projects--tiles .project-info");
        }), 100, "project-tiles-resize-events");
    }))), $(".careers--carousel").slick({
        arrows: !1,
        dots: !1,
        pauseOnHover: !1,
        pauseOnFocus: !1,
        autoplay: !0,
        autoplaySpeed: 5e3,
        swipeToSlide: !1,
        fade: !0,
        draggable: !1
    }), jQuery(document).on("gform_post_render", (function(e, form_id) {
        $(".gform_next_button").show(), $(".gfield_select").each((function() {
            $(this).select2({
                minimumResultsForSearch: -1,
                dropdownCssClass: "filter-dropdown",
                containerCssClass: "filter-sector-select2",
                width: "auto"
            });
        }));
    })), $(".section--single-insight .back-btn, .section--single-person .back-btn, .page-back-btn").click((function() {
        "#" === this.getAttribute("href") && window.history.back();
    })), $("#secondary>li>a").click((function() {
        $(this).removeClass("inactive").addClass("active"), $("#secondary > li").removeClass("show--menu"), 
        _searchForm.removeClass("show--menu"), _contactForm.removeClass("show--menu"), setTimeout((function() {
            $("#primary-mobile").removeClass("mobile--menu-open");
        }), 250);
    })), $(document).on("click", 'a:not(a[href*="#"]):not([data-lity]):not(.share)', (function(event) {
        if ("_blank" != this.getAttribute("target")) {
            $(".preloader").removeClass("page--loaded");
            var thehref = this.getAttribute("href");
            event.preventDefault(), setTimeout((function() {
                window.location = thehref;
            }), 250);
        }
    }));
    var divCount = $("#gform_wrapper_1 .gform_page").length;
    $("#gform_wrapper_1 .gf_step").each((function() {
        var current = $(this).text();
        $(this).html(current + " - " + divCount);
    }));
    var divCount_2 = $("#gform_wrapper_2 .gform_page").length;
    if ($("#gform_wrapper_2 .gf_step").each((function() {
        var current = $(this).text();
        $(this).html(current + " - " + divCount_2);
    })), jQuery(document).on("gform_page_loaded", (function(event, form_id, current_page) {
        var divCount = $("#gform_wrapper_" + form_id + " .gform_page").length;
        $("#gform_wrapper_" + form_id + " .gf_step").each((function() {
            var current = $(this).text();
            $(this).html(current + " - " + divCount);
        }));
    })), $("#ja-category").select2({
        minimumResultsForSearch: -1,
        dropdownCssClass: "filter-dropdown filter-jobadder",
        containerCssClass: "filter-sector-select2 jobadder-select2",
        width: "100%"
    }), $("#ja-location").select2({
        minimumResultsForSearch: -1,
        dropdownCssClass: "filter-dropdown filter-jobadder",
        containerCssClass: "filter-sector-select2 jobadder-select2",
        width: "100%"
    }), $("#ja-work_type").select2({
        minimumResultsForSearch: -1,
        dropdownCssClass: "filter-dropdown filter-jobadder",
        containerCssClass: "filter-sector-select2 jobadder-select2",
        width: "100%"
    }), _jobadderSearch = $("#job_filter"), _jobadderSearch.submit((function(e) {
        e.preventDefault();
        var $searchCat = $("#ja-category").children("option:selected").val(), $searchLocation = $("#ja-location").children("option:selected").val(), $searchType = $("#ja-work_type").children("option:selected").val();
        _jobadderSearch.find("button").toggleClass("searching"), $.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: "post",
            data: {
                action: "chriate_jobadder_search",
                category: $searchCat,
                location: $searchLocation,
                worktype: $searchType
            },
            success: function(result) {
                _jobadderSearch.find("button").toggleClass("searching"), $(".job__posts").html(result);
            },
            error: function() {
                console.log("error"), alert("error");
            }
        });
    })), $(document).on("click", ".job__post_readmore", (function(e) {
        e.preventDefault();
        var $this = $(this), link = $this.attr("data-href");
        $this.addClass("loading"), $.ajax({
            url: link,
            method: "GET",
            success: function(response) {
                var $jobSingle = $("<div>").html(response).find(".job__single");
                $jobSingle.length ? ($(".job_page").html($jobSingle.html()), setTimeout((function() {
                    $(".application-form").removeClass("show-form"), $(".register-with-us-form").hide(), 
                    $(".job__wrapper_1, .job__wrapper_3").fadeOut(200, (function() {
                        $(".job__wrapper_2").fadeIn(200, (function() {
                            $(".job__wrapper_2").addClass("show");
                        }));
                    })), goToByScroll("jobadder-search", 98, 250);
                }), 1e3)) : console.error(".job__single element not found in the response");
            },
            error: function(xhr, status, error) {
                console.error("Failed to fetch the content:", error);
            },
            complete: function() {
                $this.removeClass("loading");
            }
        });
    })), $(".register-with-us-tab").click((function(e) {
        $(".job__wrapper_1, .job__wrapper_2").fadeOut(200, (function() {
            $(".application-form").removeClass("show-form"), setTimeout((function() {
                $(".job__wrapper_2").removeClass("show"), $(".job__wrapper_3").fadeIn(200);
            }), 200);
        }));
    })), $(".job-search-tab").click((function(e) {
        $(".job__wrapper_2, .job__wrapper_3").fadeOut(200, (function() {
            $(".application-form").removeClass("show-form"), setTimeout((function() {
                $(".job__wrapper_2").removeClass("show"), $(".job__wrapper_1").fadeIn(200);
            }), 200);
        }));
    })), $(".job__wrapper_3").hide(), $(".job_back_to_top").click((function(e) {
        e.preventDefault(), e.stopPropagation(), goToByScroll("jobadder-search", 98, 250);
    })), $(document).on("click", ".job__apply", (function(e) {
        e.preventDefault(), e.stopPropagation(), $(".application-form").addClass("show-form"), 
        goToByScroll("application-form", 98, 250);
        var jid = $(this).attr("data-job-id");
        return $("#input_5_9").val(jid), !1;
    })), viewport.width >= 1681) var globOffset = 96; else globOffset = 25;
    function goToByScroll(id, offset, duration) {
        $("html,body").animate({
            scrollTop: $("#" + id).offset().top - offset
        }, duration);
    }
    function parallaxImages() {
        $(window).width() > 991 ? $(".js-img-parallax").each((function() {
            var top = .65 * $(this).outerHeight();
            $(this).css({
                position: "relative",
                top: "-" + top + "px"
            });
        })) : $(".js-img-parallax").each((function() {
            var top = .85 * $(this).outerHeight();
            $(this).css({
                position: "absolute",
                top: "-" + top + "px"
            });
        }));
    }
    if ($(document).on("gform_post_render", (function(e, form_id, page) {
        $(".ginput_container_fileupload").each((function() {
            var $this = $(this);
            $this.find("input").on("change", (function() {
                "" == $this.find(".validation_message").html() && $this.addClass("file-added");
            }));
        }));
    })), $(".js-preview").on("mouseenter", (function() {
        $this = $(this), $this.parent().siblings().each((function() {
            $(this).find("a").removeClass("active"), $(".preview-images").find(".active").removeClass("active");
            let index = $this.data("index");
            $('.preview-image[data-index="' + index + '"').addClass("active");
        })), $this.addClass("active").addClass("active");
    })), $("body").is(".page-template-template-studio, .page-template-template-studio-2024, .page-template-page-join-us, .page-template-template-DigitalTechnology")) {
        var canClick = !0;
        $(document).on("click", ".js-studio-nav a, .js-join-us-nav a", (function(e) {
            if ($this = $(this), $(this).parent().hasClass("active") || $(this).hasClass("js-anchor-link") || 0 == canClick) return;
            if ($(".people--filter, .js-people-back").has($this).length) return;
            $(this).parent().siblings().removeClass("active"), $(this).parent().addClass("active"), 
            $(".people--filter").fadeOut(200), 0 == $this.parents(".js-join-us-nav").length && $this.data("bg") && ($(".top--bar").attr("class", $(".top--bar").data("base-class")), 
            $(".top--bar").addClass($this.data("bg")), $(".section--projects").attr("data-bg", $this.data("bg")));
            let id = $(this).attr("href");
            canClick = !1, $(id).siblings().fadeOut(200), setTimeout((function() {
                $(id).fadeIn(200, (function() {
                    $(".anim-in--left, .anim-in--right").filter(":visible").not(".anim-in--active").addClass("anim-in--active"), 
                    canClick = !0, "#our-people" == id && ($(".iso-grid-people").show().isotope({
                        itemSelector: ".iso-grid-item-people"
                    }), $(".iso-grid-people").removeClass("are-images-unloaded"), $(".people--filter").fadeIn(200));
                }));
            }), 200), $(".nav-back").fadeOut(200), $(".people-popup.active").removeClass("active"), 
            $(".people--filter").fadeOut(200), $(".main-content").css("height", "auto"), "#recognition" == id ? "function" == typeof $(".award-slider").slick && $(".award-slider").hasClass("slick-initialized") ? ($(".award-slider").slick("refresh"), 
            setTimeout((function() {
                $(".award-slider").addClass("active");
            }), 500)) : $(".award-slider").on("init reInit", (function(event, slick) {
                setTimeout((function() {
                    $(".award-slider").slick("refresh"), $(".award-slider").addClass("active");
                }), 500);
            })) : setTimeout((function() {
                $(".award-slider").removeClass("active");
            }), 500);
        }));
    }
    if ($(window).on("scroll", (function() {
        $(window).scrollTop() > 0 ? ($("#gp-icon-logo").css({
            opacity: "1"
        }), $("#gp-logo").css({
            opacity: "0"
        })) : ($("#gp-icon-logo").css({
            opacity: "0"
        }), $("#gp-logo").css({
            opacity: "1"
        })), function handleHeroFade() {
            if ($(window).width() > 767) {
                var opacity = ($(window).scrollTop() / $(".faded-background").outerHeight()).toFixed(2);
                $(".faded-background").css("opacity", opacity), opacity > .2 ? $(".section-2").css("pointer-events", "auto") : $(".section-2").css("pointer-events", "none");
            }
        }();
    })).on("load resize", (function() {
        $("body").css("--window-height", $(window).outerHeight() + "px").find(".studio-content").closest(".main-content").css("--studio-content-offset-top", (function() {
            return $(this).offset().top;
        }));
    })), $((function() {
        if ($(".studio-content").hasClass("image-float")) {
            let $floatContainers = $(".studio-content.image-float");
            const containedImageResizeObserver = new ResizeObserver((entries => {
                for (let entry of entries) {
                    let $sideMedia = $("img, video", entry.target).filter(":visible"), $floatImage = $sideMedia.closest($floatContainers).find(".image--floating");
                    $floatImage.filter(":visible").css("margin-top", $sideMedia.innerHeight() - (parseInt($floatImage.css("padding-top")) + .5 * $floatImage.height()));
                }
            }));
            $(window).on("load", (function(e) {
                $(".image-container, .image-container-alt", $floatContainers).each((function(i, elem) {
                    containedImageResizeObserver.observe(elem);
                }));
            }));
        }
    })), window.location.hash) {
        let target = window.location.hash, $hashLink = $('a[href="' + target + '"]'), $article = $('section[data-module-id="' + target.replace("#", "") + '"]');
        $(".js-studio-nav, .js-join-us-nav").has($hashLink).length ? ($hashLink.trigger("click"), 
        $(window).on("load", (function() {
            setTimeout((function() {
                $(target).addClass("js-hash-loaded");
            }), 1e3);
        }))) : $article.length && $("html, body").animate({
            scrollTop: $article.offset().top - globOffset
        }, 100);
    }
    $(window).on("load", (function() {
        $("body").hasClass("single-people") && $(".person-images img").addClass("active");
    })), $(window).on("scroll resize", (function() {
        parallaxImages();
    })), (() => {
        var hash = window.location.hash.substring(1);
        if (hash) {
            var $targetSection = $('[data-section-id="' + hash + '"]'), headerHeight = $(".top--bar").outerHeight() ?? 0;
            $targetSection.length && $("html, body").animate({
                scrollTop: $targetSection.offset().top - headerHeight
            }, 0);
        }
    })(), console.log("Initializing plyr"), $(".plyr").each((function() {
        try {
            let $this = $(this), videoId = $this.attr("id"), autoplay = "true" === $this.attr("data-autoplay"), videoType = $this.data("video-type"), poster = $this.attr("data-poster"), allowFullscreen = "true" === $this.attr("data-allow-fullscreen"), controls = "true" === $this.attr("data-controls") ? [ "play-large", "play", "progress", "current-time", "mute", "volume", "captions", "settings", "pip", "airplay", "fullscreen" ] : [];
            "true" === $this.attr("data-mute-button") && (controls = [ "mute" ]);
            const videoSettings = {
                clickToPlay: "true" === $this.attr("data-click-to-play"),
                controls: controls,
                loop: {
                    active: "true" === $this.attr("data-loop")
                },
                autoplay: autoplay && "embed" === videoType,
                fullscreen: {
                    enabled: allowFullscreen
                },
                storage: {
                    enabled: !1
                }
            }, player = new Plyr("#" + videoId, videoSettings);
            let classes = $this.attr("class");
            $(player.elements.container).addClass(classes), poster && (player.poster = $this.attr("data-poster")), 
            autoplay && "file" === videoType && (player.muted = !0);
            let observer = new IntersectionObserver((entries => {
                entries.map((entry => {
                    entry.isIntersecting && autoplay && player ? player.play() : player.pause();
                }));
            }), {
                rootMargin: "-15% 0%",
                threshold: 0
            });
            player.on("ready", (() => {
                player.pause(), player.muted = !0, observer.observe($this[0]);
            })), player.on("muted", (event => {
                event.detail.muted || (player.volume = .5);
            }));
        } catch (error) {
            "Plyr is not defined" !== error.message ? console.error("Error initializing Plyr:", error) : console.error("Plyr is not defined.");
        }
    }));
}(jQuery, window, document);